/**
 * Thin logger utility — silent in production builds, useful in development.
 *
 * CRA's `process.env.NODE_ENV` is statically replaced at build time, so
 * production bundles strip out the log function bodies via dead-code elimination.
 *
 * Use this instead of bare `console.*` calls for non-user-facing diagnostics
 * (token bootstrap failures, localStorage unavailable, optional plugin missing).
 */

const isDev =
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV !== "production";

const noop = () => {};

export const logger = {
  debug: isDev ? console.debug.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  // Errors are always reported — they should not be silenced even in production.
  error: console.error.bind(console),
};

export default logger;
